/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */


//myParaxify = paraxify('.background-top');



if(window.location.href.indexOf('customer_posted=true') > -1){
          $([document.documentElement, document.body]).animate({
             scrollTop: $('#footer-newsletter').offset().top
          }, 10);
      }


function announcementSlider(){
  
    //Define the current img
    var current = $('#announcementSlider .show');
    //If index != 0/false then show next img
  var next = current.next().length ? 
      current.next() :
      // if index == false then show first img
      current.siblings().first();
  
   //*** Swap out the imgs and class ***//
   current.hide().removeClass('show');
   next.fadeIn("slow").addClass('show');
  
  
  //*** Repeat function every 3 seconds ***//
  setTimeout(announcementSlider, 3300);
  
};


jQuery(document).ready(function ($) {
  if ($('.announcementSlide').length>1) setTimeout(announcementSlider, 3300);
})




function resizeBackground() {//supposed to eliminat bkgd image shift on mobile when browser chrome (address bar / footer) show/hide when scrolling
    $('.section-testimonials:before').height( $(window).height() + 60);
}

$(window).resize(resizeBackground);
resizeBackground();


var credits = document.getElementById("credits");

function showCredits() {
  fadeIn(credits);
} 
function hideCredits() {
  fadeOut(credits);
}
function isHidden() {
  var el = document.querySelector(".Footer__ThemeCredits");
  console.log( el.offsetParent === null );
    return (el.offsetParent === null)
}

function fadeOut(element) {
    var op = 1;  // initial opacity
    var timer = setInterval(function () {
        if (op <= 0.1){
            clearInterval(timer);
            element.style.display = 'none';
        }
        element.style.opacity = op;
        element.style.filter = 'alpha(opacity=' + op * 100 + ")";
        op -= op * 0.1;
    }, 50);
}

function fadeIn(element) {
    var op = 0.1;  // initial opacity
    element.style.display = 'block';
    var timer = setInterval(function () {
        if (op >= 1){
            clearInterval(timer);
        }
        element.style.opacity = op;
        element.style.filter = 'alpha(opacity=' + op * 100 + ")";
        op += op * 0.1;
    }, 10);
}




//CD
var qty,url;
jQuery('body').on('change', '.chkGiftProduct', function(event) {
	var giftVars = document.querySelectorAll('.giftProductVariants');
  
    if(this.classList.contains('chkGiftProductDefault')) {
      if(this.checked) {
        qty = 1;
        url = '/cart/add.js';
      } else {
        qty = 0;
        url = '/cart/change.js';
      }
      document.querySelectorAll('.giftProductWrap')[0].classList.add('processing');
      var varId = this.getAttribute('data-id');
      var xhttp = new XMLHttpRequest();
      xhttp.onreadystatechange = function() {
        if (this.readyState == 4 && this.status == 200) {
          document.dispatchEvent(new CustomEvent('product:added', { detail: { quantity: qty == 1 ? 1 : -1 } }));
          document.querySelectorAll('.giftProductWrap')[0].classList.remove('processing');
        }
      };
      xhttp.open("POST", url, true);
      xhttp.setRequestHeader("Content-Type","application/json");
      xhttp.send(JSON.stringify({id:varId, quantity:qty}));
      return;
    }
    if(this.checked) {  
      
      jQuery('.chkGiftVariant').prop('required',true); // if gift wrap option was selected, make sure the radio buttons to select the type of gift wrap (variants) are required
      
      for (var j = 0; j < giftVars.length; j++) {
        giftVars[j].classList.add('active');
      }
			document.getElementById('giftProductVariants__wrap').classList.add('active');
    } else {
      
      jQuery('.chkGiftVariant').prop('required',false); // if gift wrap option was not selected, make sure the radio buttons to select the type of gift wrap (variants) are not required
      
      if(document.querySelectorAll('.freeProductRow').length) {
        document.querySelectorAll('.giftProductWrap')[0].classList.add('processing');
        var varId = document.querySelectorAll('.freeProductRow')[0].getAttribute('data-id');
        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function() {
          if (this.readyState == 4 && this.status == 200) {
            document.dispatchEvent(new CustomEvent('product:added', { detail: { quantity: -1 } }));
            document.querySelectorAll('.giftProductWrap')[0].classList.remove('processing');
          }
        };
        xhttp.open("POST", "/cart/change.js", true);
        xhttp.setRequestHeader("Content-Type","application/json");
        xhttp.send(JSON.stringify({id:varId, quantity:0}));
      } 
      for (var j = 0; j < giftVars.length; j++) {
        giftVars[j].classList.remove('active');
      }
			document.getElementById('giftProductVariants__wrap').classList.remove('active');
    }
  });

jQuery('body').on('change', '.chkGiftVariant', function(event) {
    if(this.checked) {
      document.querySelectorAll('.giftProductWrap')[0].classList.add('processing');
      if(document.querySelectorAll('.freeProductRow').length) {
        var varId = document.querySelectorAll('.freeProductRow')[0].getAttribute('data-id');
        var updates = {};
        updates[this.value] = 1;
        updates[varId] = 0;
        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function() {
          if (this.readyState == 4 && this.status == 200) {
            document.dispatchEvent(new CustomEvent('product:added', { detail: { quantity: 1 } }));            
            document.querySelectorAll('.giftProductWrap')[0].classList.remove('processing');
          }
        };
        xhttp.open("POST", "/cart/update.js", true);
        xhttp.setRequestHeader("Content-Type","application/json");
        xhttp.send(JSON.stringify({updates: updates}));
      } else {
        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function() {
          if (this.readyState == 4 && this.status == 200) {
            document.dispatchEvent(new CustomEvent('product:added', { detail: { quantity: 1 } }));
            document.querySelectorAll('.giftProductWrap')[0].classList.remove('processing');
          }
        };
        xhttp.open("POST", "/cart/add.js", true);
        xhttp.setRequestHeader("Content-Type","application/json");
        xhttp.send(JSON.stringify({id:this.value, quantity:1}));
      }
    }
  });

jQuery('.Drawer__Footer .Cart__Checkout').on('click', function(e) {
  
    if ($('.chkGiftProduct').is(':checked') && !$(".Cart__Note").val() ) {
		//alert('Please add a Gift note');
        $('.Cart__Note').addClass('required');
        e.preventDefault();
    } else {
      $('.Cart__Note').removeClass('required')
    }
});


/* for bundle builder: to enable drawer cart (ajax cart), uncomment the following three lines */
//function bbAfterAddToCart() {
	//document.dispatchEvent(new CustomEvent('product:added', { detail: { quantity: 1 } }));
//}

/* Wear It With PDP feature */
(()=> { 
	const wiwEl = document.getElementById('wiw');
	if(wiwEl !== null){
		async function fetchProducts() {
			try {
				const response = await fetch(window.Shopify.routes.root + `recommendations/products.json?product_id=${wiwEl.dataset.productId}&limit=7`);
				if (!response.ok) { throw new Error(`error: ${response.status}`); }
				const data = await response.json();
				return data;
			} catch (e){
				console.log(e);
			}
		};
		fetchProducts().then( data => {
			if (data.products.length > 0) {
				let html = `<div id="wiw-title">${wiwEl.dataset.title}</div><div id="wiw-products">`;
				let limit = 3;
				let displayed = 0;
              console.log('products')
              console.log(data.products)
				data.products.forEach(p =>{
                  console.log('p')
                  					console.log(p)
					if(p.handle != 'gift-wrap' && p.type != 'Content Block' && p.featured_image && displayed < limit){
						let image = p.featured_image;
						const re = /(\.jpg|\.png|\.gif)/gi;
						image = image.replace(re, '_300x$1');
						html += `<a href="${p.url}">`
						html += `<img class="Image--lazyLoad Image--fadeIn" src="${image}" alt="${p.title}">`
						html += `</a>`
						displayed++;
					}
				});
				html += '</div></div>';
				wiwEl.innerHTML = html;
			}
		});
	}
})();
/* end Wear It With */

/* In Cart Upsell */
(()=> { 
	let cartData = null;
	let cartDataPrevious = null;
	async function fetchCart(){
		try {
			const response = await fetch(window.Shopify.routes.root + 'cart.js');
			if (!response.ok) { throw new Error(`error: ${response.status}`); }
			const data = await response.json();
			cartData = data;
			return data;
		} catch (e){
			console.log(e);
		}
	}

	async function fetchProducts(productId) {
		try {
			const response = await fetch(window.Shopify.routes.root + `recommendations/products.json?product_id=${productId}`);
			if (!response.ok) { throw new Error(`error: ${response.status}`); }
			const data = await response.json();
			return data;
		} catch (e){
			console.log(e);
		}
	};

	function buildProductList(data){
		if (data.products.length > 0) {
			// build array of products to display
			// remove any product that is already in the cart
			let outputArr = []; 
			for(i=0; i < data.products.length; i++ ){
				if(!cartData.items.some(item => item.product_id == data.products[i].id)){
					outputArr.push(data.products[i])
				}
				if(outputArr.length == 4) {
					break;
				}
			}

			let html = ``;
			outputArr.forEach( p => {
				let image = p.featured_image;
				const re = /(\.jpg|\.png|\.gif)/gi;
				image = image.replace(re, '_300x$1');
				html += `<div class="upsell__product">`
				html += `<a href="${p.url}">`
				html += `<img class="Image--lazyLoad Image--fadeIn" src="${image}" alt="${p.title}">`
				html += `</a>`
				html += `<div class="content">`
				html += `<a href="${p.url}" class="product__item-summary">`
				html += `<div class="product__item-name">${p.title}</div>`
				html +=	`</a>`
				//html += `<button class="Button Button--primary Button--upsellATC" data-vid="${p.variants[0].id}">Add - $${p.price* .01}</button>`
				html += `<button class="Button Button--primary Button--upsellATC" data-vid="${p.variants[0].id}">Add - $${p.price* .01}</button>`
				html += `</div>`
				html += `</div>`
			});
   
			// only add items on desktop if it's the first load or not the same as the previous items
			if(cartDataPrevious){
				if(cartData.items[0].id != cartDataPrevious.items[0].id){
					document.getElementById('upsell').getElementsByClassName('upsell__products')[0].innerHTML = html;
				}
			} else {
				document.getElementById('upsell').getElementsByClassName('upsell__products')[0].innerHTML = html;
			}

			// mobile
			let mobileUpsells = document.getElementById('upsell-mobile');
			if(mobileUpsells == null){
				let mobileUpsellDiv = document.createElement("div");
				mobileUpsellDiv.id = "upsell-mobile";
				let upsellLabel = document.getElementById('upsell').getElementsByClassName('upsell__label')[0].innerHTML;
				mobileUpsellDiv.innerHTML = 
				`<div class="upsell__inner">
					<p class="upsell__label text-center">${upsellLabel}</p>
					<div class="upsell__products-outer">
						<div class="upsell__products"></div>
					</div>
				</div>`;
				const target = document.getElementsByClassName('Cart__ItemList')[0];
				target.parentNode.insertBefore(mobileUpsellDiv, target.nextSibling);

				document.getElementById('upsell-mobile').getElementsByClassName('upsell__products')[0].innerHTML = html;
			}
			

			// add atc click event
			Array.from(document.getElementsByClassName('Button--upsellATC')).forEach( el => {
				el.addEventListener('click', async e => {
					e.preventDefault();

					const variantId = e.target.dataset.vid;

					const formData = {
						items: [{
							id: variantId,
							quantity: 1
						}]
					};
					fetch(window.Shopify.routes.root + 'cart/add.js', {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json'
						},
						body: JSON.stringify(formData)
					})
					.then(response => {
						document.dispatchEvent(new CustomEvent('product:added', { detail: { quantity: 1 } }));
						//init();
					})
					.catch((error) => {
						console.error('Error:', error);
					});
				})
			})
		}
	}

	function init(){
		const source = document.getElementById('upsell').dataset.upsellSource;
		if(source == "collection") {
			fetchCart().then(data => { 
				if(data.items.length < 1){
					document.getElementById('upsell').style.right = '-960px';
					return;
				} else {
					document.getElementById('upsell').style.removeProperty('right');
				}
				buildProductList(upsellProducts);
				cartDataPrevious = cartData;
			})
		} else {
			fetchCart().then(data => { 
				if(data.items.length < 1){
					document.getElementById('upsell').style.right = '-960px';
					return;
				} else {
					document.getElementById('upsell').style.removeProperty('right');
				}
				fetchProducts(data.items[0].product_id).then( data => {
					buildProductList(data);
					cartDataPrevious = cartData;
				});
			})
		}
	}
	let inCartUpsells = document.getElementById('upsell');
	if(inCartUpsells != null){
		init();
	}

	// watch cart item list for changes
		let previousCartContent = 0;
		if(document.getElementsByClassName('Cart__ItemList').length){
			previousCartContent = document.getElementsByClassName('Cart__ItemList')[0].innerHTML.length;
		}
		setInterval(() => {
			let currentCartContent = 0;
			if(document.getElementsByClassName('Cart__ItemList').length){
				currentCartContent = document.getElementsByClassName('Cart__ItemList')[0].innerHTML.length;
			}
			if(previousCartContent !== currentCartContent){
				//console.log('change')
				init();
				giftnoteInit()
				previousCartContent = currentCartContent;
			}
		}, 1000)

	function giftnoteInit(){
		var cartNoteApp = new Vue({
			el: '#cartNoteApp',
			data: {
				test: "test",
				to: "",
				from: "",
				message: ""
			},
			computed: {
				note(){
					let toText = ''
					if(this.to){
						toText = `To: ${this.to}, \r\n`;
					}
					let fromText = ''
					if(this.from){
						fromText = `From: ${this.from}, \r\n`;
					}
					let messageText = ''
					if(this.message){
						messageText = `"${this.message}"`;
					}
					return `${toText}${fromText}${messageText}`
				}
			},
			mounted(){
				if(document.getElementById('toHidden')){
					this.to = document.getElementById('toHidden').value;
				}
				if(document.getElementById('fromHidden')){
					this.from = document.getElementById('fromHidden').value;
				}
				if(document.getElementById('messageHidden')){
					this.message = document.getElementById('messageHidden').value;
				}

				if(document.getElementById('gift-message')){
					// remove emojis from note
					let giftNote = document.getElementById('gift-message');
					giftNote.addEventListener('input', () => {
						let giftNoteText = giftNote.value;
						let updatedgiftNoteText = giftNoteText.replace(emojiRe, '');
						giftNote.value = updatedgiftNoteText;
					})
				}
			}
		})
	}
	giftnoteInit();

})();
/* End In Cart Upsell */

/* Start Product Card Quick ATC */
(function() {
  var quickAtcElements = document.getElementsByClassName('quick-atc');
  if (quickAtcElements && quickAtcElements.length > 0) {
    // Use Array.from if available, otherwise convert manually
    var elementsArray = Array.from ? Array.from(quickAtcElements) : Array.prototype.slice.call(quickAtcElements);
    
    elementsArray.forEach(function(el) {
      var atcBtn = el.getElementsByClassName('atc-btn')[0];
      var quantityMinus = el.getElementsByClassName('quantity-minus')[0];
      var quantityPlus = el.getElementsByClassName('quantity-plus')[0];
      
      if (!atcBtn || !quantityMinus || !quantityPlus) {
        return; // Skip if required elements don't exist
      }
      
      atcBtn.addEventListener('click', async function(e) {
        e.preventDefault();

        var quantityInput = el.getElementsByClassName('quantity-input')[0];
        if (!quantityInput) return;
        
        var quantity = quantityInput.value;
        var variantId = e.target.dataset.vid;

        var formData = {
          items: [{
            id: variantId,
            quantity: quantity
          }]
        };
        
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
        .then(function(response) {
          document.dispatchEvent(new CustomEvent('product:added', { detail: { quantity: 1 } }));
        })
        .catch(function(error) {
          console.error('Error:', error);
        });
      });

      quantityMinus.addEventListener('click', function(e) {
        var quantityInput = el.getElementsByClassName('quantity-input')[0];
        if (quantityInput && Number(quantityInput.value) > 1) {
          quantityInput.value = Number(quantityInput.value) - 1;
        }
      });

      quantityPlus.addEventListener('click', function(e) {
        var quantityInput = el.getElementsByClassName('quantity-input')[0];
        if (quantityInput && Number(quantityInput.value) < 20) {
          quantityInput.value = Number(quantityInput.value) + 1;
        }
      });
    });
  }
})();
/* End Product Card Quick ATC */

/* Fix accessibility: aria-hidden elements containing focusable descendants */
(function() {
  'use strict';
  
  // Get all focusable elements within a container
  function getFocusableElements(container) {
    var focusableSelectors = [
      'a[href]',
      'button:not([disabled])',
      'input:not([disabled])',
      'select:not([disabled])',
      'textarea:not([disabled])',
      '[tabindex]:not([tabindex="-1"])'
    ].join(', ');
    
    return container.querySelectorAll ? container.querySelectorAll(focusableSelectors) : [];
  }
  
  // Update tabindex for focusable elements in a cell based on aria-hidden state
  function updateCellFocusable(cell) {
    var isHidden = cell.getAttribute('aria-hidden') === 'true';
    var focusableElements = getFocusableElements(cell);
    
    Array.prototype.forEach.call(focusableElements, function(element) {
      if (isHidden) {
        // Store original tabindex if it exists, then set to -1
        if (element.hasAttribute('tabindex')) {
          element.setAttribute('data-original-tabindex', element.getAttribute('tabindex'));
        } else {
          element.setAttribute('data-original-tabindex', '');
        }
        element.setAttribute('tabindex', '-1');
      } else {
        // Restore original tabindex
        var originalTabindex = element.getAttribute('data-original-tabindex');
        if (originalTabindex === '') {
          element.removeAttribute('tabindex');
        } else if (originalTabindex !== null) {
          element.setAttribute('tabindex', originalTabindex);
        }
        element.removeAttribute('data-original-tabindex');
      }
    });
  }
  
  // Process all carousel cells on page load
  function processAllCarouselCells() {
    var carouselCells = document.querySelectorAll('.Carousel__Cell');
    Array.prototype.forEach.call(carouselCells, function(cell) {
      updateCellFocusable(cell);
    });
  }
  
  // Watch for aria-hidden changes using MutationObserver
  function watchCarouselCells() {
    var carouselCells = document.querySelectorAll('.Carousel__Cell');
    
    Array.prototype.forEach.call(carouselCells, function(cell) {
      // Create observer for each cell
      var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden') {
            updateCellFocusable(cell);
          }
        });
      });
      
      // Observe aria-hidden attribute changes
      observer.observe(cell, {
        attributes: true,
        attributeFilter: ['aria-hidden']
      });
    });
  }
  
  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      processAllCarouselCells();
      watchCarouselCells();
    });
  } else {
    processAllCarouselCells();
    watchCarouselCells();
  }
  
  // Also watch for dynamically added carousels (e.g., after AJAX)
  var carouselObserver = new MutationObserver(function(mutations) {
    var shouldUpdate = false;
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length) {
        Array.prototype.forEach.call(mutation.addedNodes, function(node) {
          if (node.nodeType === 1) {
            if (node.classList && node.classList.contains('Carousel__Cell')) {
              shouldUpdate = true;
            } else if (node.querySelector && node.querySelector('.Carousel__Cell')) {
              shouldUpdate = true;
            }
          }
        });
      }
    });
    
    if (shouldUpdate) {
      setTimeout(function() {
        processAllCarouselCells();
        watchCarouselCells();
      }, 100);
    }
  });
  
  // Start observing the document body for new carousel cells
  if (document.body) {
    carouselObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})();